<template>
  <popup
    class="rb-popup-filters"
    title="Filters"
    :active="active"
    :on-screen="onScreen"
    @close="close"
  >
    <div class="rb-center">
      <div class="rb-center-content">
        <div :class="'rb-filter-group'">
          <div class="rb-fg-title">
            <h3>Price Range</h3>
          </div>
          <div class="rb-fg-options">
            <price-range
              :thumbsize="14"
              :range-width="300"
              :range-min="0"
              :range-max="250000"
              :is-currency="true"
              type="retail_price"
            />
          </div>
        </div>
        <div :class="'rb-filter-group'">
          <div class="rb-fg-title">
            <h3>Carat Weight</h3>
          </div>
          <div class="rb-fg-options">
            <price-range
              :thumbsize="14"
              :range-width="300"
              :range-min="0"
              :range-max="800"
              type="carats"
              :reducer="40"
            />
          </div>
        </div>
        <filter-group
          :filters="filters.filterShapes"
          :applied-filters="appliedFilters"
          help-id="rb-popup-diamond-guide"
          title="Shape"
          description="Please note that this will change your selection from step 1"
          :descriptionWarn="true"
          :images="true"
          type="shape"
        ></filter-group>
        <filter-group
          :filters="filters.filterColors"
          help-id="rb-popup-diamond-guide"
          title="Color"
          description="Select all that apply"
          type="color"
          :applied-filters="appliedFilters"
        ></filter-group>
        <filter-group
          :filters="filters.filterClarities"
          help-id="rb-popup-diamond-guide"
          title="Clarity"
          description="Select all that apply"
          type="clarity"
          :applied-filters="appliedFilters"
        ></filter-group>
      </div>
    </div>
    <div class="rb-bottom">
      <button
        aria-label="Apply Filters"
        class="btn rb-btn-apply-filters"
        @click.prevent="applyFilters"
        id="btn-apply-filters"
      >
        Apply Filters
      </button>
    </div>
  </popup>
</template>

<script>
/**
 * Displays a popup with filters
 *
 * @implements
 * PopupMixin
 * CommMixin
 * TrackMixin
 *
 * @props
 * filters: Object
 * appliedFilters: Array
 *
 * @emits
 * rb-apply-filters
 */
import CommMixin from "@/mixins/CommMixin";
import TrackMixin from "@/mixins/TrackMixin";
import Popup from "@/components/Popup";
import PopupMixin from "@/mixins/PopupMixin";
import FilterGroup from "@/components/FilterGroup";
import PriceRange from "@/components/PriceRange";
export default {
  components: { Popup, FilterGroup, PriceRange },
  mixins: [PopupMixin, CommMixin, TrackMixin],
  props: {
    filters: {
      type: Object,
    },
    appliedFilters: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    applyFilters: function (event) {
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
      this.broadcast("rb-apply-filters", this.appliedFilters);
      this.close();
    },
  },
};
</script>
